import { GANTT_BIND_TYPE_LIST, SectionType } from '@gantt/components/GanttCreateOrEdit'
import {
  EMPTY_COMMAND_FORM,
  RESOURCE_KEY_FIELD_PREFIX,
  RESOURCE_LINK_FIELD_PREFIX,
  timelineItemTitlesDefaultValue,
} from '@gantt/constants'

const fieldDefaultWithCommands = {
  field: '',
  pathStr: '',
  pathArray: [],
  commands: EMPTY_COMMAND_FORM,
}

const fieldDefault = {
  field: '',
  pathStr: '',
  pathArray: [],
}

export const getGanttSegmentDefaultValue = (code: number): SectionType => {
  const systemName = `segment_${code}`

  return {
    id: '',
    title: {
      bindType: GANTT_BIND_TYPE_LIST.STATIC,
      static: undefined,
    },
    titles: structuredClone(timelineItemTitlesDefaultValue),
    segmentHeight: {
      bindType: GANTT_BIND_TYPE_LIST.STATIC,
      static: undefined,
    },
    tooltip: {
      bindType: GANTT_BIND_TYPE_LIST.FIELD_ARRAY,
      field_array: [fieldDefault],
    },
    datetimeStart: {
      bindType: GANTT_BIND_TYPE_LIST.FIELD,
      field: fieldDefaultWithCommands,
    },
    datetimeEnd: {
      bindType: GANTT_BIND_TYPE_LIST.FIELD,
      field: fieldDefaultWithCommands,
    },
    duration: {
      bindType: GANTT_BIND_TYPE_LIST.FIELD,
      field: fieldDefault,
    },
    link: {
      axisY: {
        bindType: GANTT_BIND_TYPE_LIST.FIELD,
        field: fieldDefaultWithCommands,
      },
      axisX: {
        bindType: GANTT_BIND_TYPE_LIST.FIELD,
        field: fieldDefaultWithCommands,
      },
      resourceKeyField: RESOURCE_KEY_FIELD_PREFIX,
      resourceLinkField: RESOURCE_LINK_FIELD_PREFIX,
      systemName,
    },
    background: {
      bindType: GANTT_BIND_TYPE_LIST.STATIC,
      static: undefined,
    },
    labels: {
      leftTopTitle: {
        bindType: GANTT_BIND_TYPE_LIST.STATIC,
        static: undefined,
      },
      bottomTitle: {
        bindType: GANTT_BIND_TYPE_LIST.STATIC,
        static: undefined,
      },
      leftBottomTitle: {
        bindType: GANTT_BIND_TYPE_LIST.STATIC,
        static: undefined,
      },
      rightBottomTitle: {
        bindType: GANTT_BIND_TYPE_LIST.STATIC,
        static: undefined,
      },
      rightTopTitle: {
        bindType: GANTT_BIND_TYPE_LIST.STATIC,
        static: undefined,
      },
      topTitle: {
        bindType: GANTT_BIND_TYPE_LIST.STATIC,
        static: undefined,
      },
    },
    icons: {
      leftTopIcon: {
        bindType: GANTT_BIND_TYPE_LIST.JSX,
        jsx: undefined,
      },
      bottomIcon: {
        bindType: GANTT_BIND_TYPE_LIST.JSX,
        jsx: undefined,
      },
      leftBottomIcon: {
        bindType: GANTT_BIND_TYPE_LIST.JSX,
        jsx: undefined,
      },
      leftIcon: {
        bindType: GANTT_BIND_TYPE_LIST.JSX,
        jsx: undefined,
      },
      centerIcon: {
        bindType: GANTT_BIND_TYPE_LIST.JSX,
        jsx: undefined,
      },
      rightIcon: {
        bindType: GANTT_BIND_TYPE_LIST.JSX,
        jsx: undefined,
      },
      rightBottomIcon: {
        bindType: GANTT_BIND_TYPE_LIST.JSX,
        jsx: undefined,
      },
      rightTopIcon: {
        bindType: GANTT_BIND_TYPE_LIST.JSX,
        jsx: undefined,
      },
      topIcon: {
        bindType: GANTT_BIND_TYPE_LIST.JSX,
        jsx: undefined,
      },
    },
    lines: {
      top: {
        has: {
          bindType: GANTT_BIND_TYPE_LIST.STATIC,
          static: undefined,
        },
      },
      bottom: {
        has: {
          bindType: GANTT_BIND_TYPE_LIST.STATIC,
          static: undefined,
        },
      },
    },
    activeSegment: {
      has: { bindType: GANTT_BIND_TYPE_LIST.STATIC, static: undefined },
      color: { bindType: GANTT_BIND_TYPE_LIST.STATIC, static: undefined },
      opacity: '',
      verticalMargin: { bindType: GANTT_BIND_TYPE_LIST.STATIC, static: undefined },
      sideMargin: { bindType: GANTT_BIND_TYPE_LIST.STATIC, static: undefined },
    },
    textColor: {
      bindType: GANTT_BIND_TYPE_LIST.STATIC,
      static: undefined,
    },
    textSettings: {
      useTextSettings: false,
      fontFamily: 'Arial',
      fontSize: '14',
      isBold: false,
      isItalic: false,
      alignment: 'left',
      fontColor: '#000',
    },
  }
}
